module.exports = __webpack_public_path__ + "img/trash.d48003a0.svg";